import { ptzaConfig } from '../../controllers/config.js';

class ModulesManager {
    modules = {      
        addons: {
            export: 'ptzaAddons',
            loader: () => import('../../controllers/modules/addons/index.js'),
        },
        cart: {
            export: 'ptzaCarrito',
            loader: () => import('./cart/index.js'),
        },
        faq: {
            export: 'ptzaFaq',
            loader: () => import('./faq/index.js'),
        },
        news: {
            export: 'ptzaNews',
            loader: () => import('./news/index.js'),
        },
        panel: {
            export: 'ptzaPanel',
            loader: () => import('./panel/index.js'),
        },
    };

    async loadModule(key) {
        const moduleMeta = this.modules[key];

        if (!moduleMeta) {
            return false;
        }

        try {
            const mod = await moduleMeta.loader();
            const instance = mod[moduleMeta.export];

            if (!instance) {
                console.warn(
                    `No se encontró el export ${moduleMeta.export} para el módulo ${key}`
                );
                return false;
            }

            window.PTZA.modules[key] = instance;

            if (typeof instance.init === 'function') {
                await instance.init();
            }

            return true;
        } catch (e) {
            console.error(`Error cargando módulo ${key}:`, e);
            return false;
        }
    }

    async init() {
        const configPage = ptzaConfig.getPageConfig();
        const configAddons = ptzaConfig.getAddonsConfig();

        window.PTZA.modules = window.PTZA.modules || {};

        // Addons ya no pertenece a page; se resuelve desde la rama raíz.
        if (configAddons?.enabled === true) {
            await this.loadModule('addons');
        }

        if (!configPage || typeof configPage !== 'object') {
            return true;
        }

        for (const [key, moduleConfig] of Object.entries(configPage)) {
            if (key === 'addons' || key === 'meta') continue;
            if (!moduleConfig || moduleConfig.enabled !== true) continue;

            await this.loadModule(key);
        }

        return true;
    }

}

export const ptzaModulesManager = new ModulesManager();